module.exports = __webpack_public_path__ + "static/media/avatars_female_27.6d9860a9.png";